import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import Notifications from "./notifications";

const feature = "notifications";

const InitialState = Record({
  notifiactions: new Notifications()
});

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function NotificationsReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
        action.payload.entities &&
        action.payload.entities.notifiactions
    ) {
      state = state.updateIn(
        ["notifiactions", "entities"],
        map => map.mergeDeep(action.payload.entities.notifiactions)
      );
    }
  }

  switch (action.type) {
    case actions.PATCH_NOTIFICATION: {
      return state.setIn(["notifiactions", "loading"], true);
    }
    case actions.PATCH_NOTIFICATION_SUCCESS: {
      return state.setIn(["notifiactions", "loading"], false);
    }
    case actions.PATCH_NOTIFICATION_ERROR: {
      return state.setIn(["notifiactions", "loading"], false);
    }

  }

  return entitiesReducer(state, feature, action);
}



// WEBPACK FOOTER //
// ./src/common/notifications/reducer.js